import { getContent } from '@/utils/tools';
import { REPLY_TYPE } from '@/utils/responseHandler';
import { handleJoinedQueue } from '@/components/Live/handleJoinedQueue';
import { handleLiveBtnClick } from '@/utils/btnClickHandler';
import { TRACKING_TYPE, TRACKING_MSG_TYPE } from '@/utils/constants';
import { updateDialogueInfo, hideDialogueChannelOptionButton } from '@/utils/sessionUtils';
import sessionStore from '@/stores/session';
import agentStore from '@/stores/agent';
import initStore from '@/stores/init';
import { BasedActionHandleProps } from '.';

enum DmLiveAgentType {
  live = REPLY_TYPE.LIVE,
  liveAgentRecommender = REPLY_TYPE.NEW_HOT_QUESTION,
  channelOptionLive = REPLY_TYPE.CHANNEL_OPTION_LIVE,
}
//  这里参考了 live/index.js 组件里的 handleJumpClick 方法
const handleDmToLiveAgent = (props: BasedActionHandleProps) => {
  const { extra, isHistory, dialogueId, dialogueType, nodePointId } = props;
  const actionOptionInfo = extra?.action_option_info ?? {};
  const actionOption = actionOptionInfo?.action ?? {};
  const actionType = actionOptionInfo.source_reply_type;
  const liveOption = actionOptionInfo?.live_option_info;
  const data = liveOption?.button_for_live ?? {};
  const { button_type, button_id } = data;
  const liveAgentAutoQueueInfo = liveOption?.live_agent_auto_queue_info;
  const isLiveAgentRecommender = actionOptionInfo.source_reply_type === DmLiveAgentType.liveAgentRecommender;
  const isChannelOptionLive = actionOptionInfo.source_reply_type === DmLiveAgentType.channelOptionLive;
  const isLive = actionOptionInfo.source_reply_type === DmLiveAgentType.live;
  const listPos = sessionStore.getCurPos() - 1;
  const trackingdata = {
    node_point_id: nodePointId || '',
    chat_session_id: initStore.sessionId,
    chat_dialogue_id: dialogueId,
    button_type: button_type,
    button_text: getContent(data),
    button_id: button_id || '',
    if_history: TRACKING_MSG_TYPE.REAL_TIME,
  };
  let trackingname = TRACKING_TYPE.AGENT;
  let userType = agentStore.userType;
  let enquiryType = agentStore.enquiryType;

  if (isLiveAgentRecommender) {
    trackingname = TRACKING_TYPE.LIVE_AGENT_RECOMMENDER;
  } else if (isChannelOptionLive) {
    trackingname = TRACKING_TYPE.CHANNEL_SELECTION;
  } else if (isLive) {
    userType = data.user_type_id;
    enquiryType = data.enquiry_type_id;
  }

  const params = {
    ...data,
    dialogueId,
    dialogueType,
    text: getContent(data),
    listPos,
    user_type: userType,
    enquiry_type: enquiryType,
    liveAgentAutoQueueInfo,
    inhouseLiveAgent: liveAgentAutoQueueInfo?.inhouse_live_agent || {},
    letUserChoose: liveAgentAutoQueueInfo?.let_user_choose,
    queueType: liveAgentAutoQueueInfo?.queue_type,
    isChatbotMsgBeforeLiveAgent: actionType === REPLY_TYPE.NEW_HOT_QUESTION, // 这里是表示是 LiveAgentRecommender
    isHistory,
    notDialogue: true,
  };

  if (isLiveAgentRecommender) {
    updateDialogueInfo({ isDisabled: true }, listPos);
  }

  if (isChannelOptionLive) {
    hideDialogueChannelOptionButton();
  }

  handleJoinedQueue(initStore.sessionId);
  handleLiveBtnClick(params, {
    trackingname,
    trackingdata,
  });
};

export default handleDmToLiveAgent;
